import React, { useMemo } from 'react';
import { MimaTable } from '../../components';
import constant from '../../utils/constant';
import { amountFormatter } from '../../utils/utils';

const CommisionTable = ({
	isLoading,
	data,
	isFetching,
	limit,
	onLimitChange,
	currentPage,
	setCurrentPage,
	setSearchQuery,
}) => {
	const tableData = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.transactions || [];
		}
		return [];
	}, [data]);

	const tableColumns = [
		{
			Header: 'Name',
			accessor: 'name',
			Cell: ({ cell }) => {
				const firstname = cell.row.original?.employee?.user?.firstname;
				const lastname = cell.row.original?.user?.lastname;
				return <span>{`${firstname}-${lastname}`}</span>;
			},
		},
		{
			Header: 'Job Role',
			Cell: ({ cell }) => {
				const jobTitle = cell.row.original?.employee?.jobTitle;

				return <span>{jobTitle}</span>;
			},
		},
		{
			Header: 'Amount',
			Cell: ({ cell }) => {
				const amount = cell.row.original?.transactionAmount;
				const currencyCode = cell.row.original?.currencyCode;
				return <span>{amountFormatter(currencyCode).format(amount)}</span>;
			},
		},
		{
			Header: 'Charge',
			Cell: ({ cell }) => {
				const chargeValue = cell.row.original?.charge;
				const currencyCode = cell.row.original?.currencyCode;
				return <span>{amountFormatter(currencyCode).format(chargeValue)}</span>;
			},
		},
		{
			Header: 'Tag',
			Cell: ({ cell }) => {
				const tag = cell.row.original?.tag;
				return <span>{tag}</span>;
			},
		},
		{
			Header: 'Status',
			Cell: ({ cell }) => {
				const status = cell.row.original?.status;
				return <span>{status}</span>;
			},
		},
		// {
		// 	Header: 'Actions',
		// 	Cell: ({ cell }) => {
		// 		const item = cell.row.original;
		// 		return (
		// 			<span
		// 				className="action-text"
		// 				onClick={() => {
		// 					goToSpecificEmployee(item);
		// 				}}>
		// 				{' '}
		// 				View More{' '}
		// 			</span>
		// 		);
		// 	},
		// },
	];

	return (
		<div>
			<MimaTable
				tableData={tableData}
				tableColumns={tableColumns}
				searchPlaceholder="Search Commission"
				searchVariant="wide"
				totalItems={data?.data?.totalCounts}
				onLimitChange={onLimitChange}
				isLoading={isLoading}
				isFetching={isFetching}
				limit={limit}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
			/>
		</div>
	);
};

export default CommisionTable;
